<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button> -->
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleCopy">复制上一年度</el-button>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <!-- <input type="text" v-model="query.keyWord" />
            <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column prop="operation" fixed="right" label="操作" width="300">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
                  v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                <el-button v-else-if="
                  scope.row.status != 1 &&
                  scope.row.status != 2 &&
                  tableAcl.indexOf('Edit') != -1
                " type="text" v-preventReClick @click="handleUpdate(scope.row)"
                  class="margin-left20 color-blue">编辑</el-button>
      
                <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
                  @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
      style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
      <template slot="empty">
        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
          <img src="../../../../assets/noData.png" width="240" height="240" />
          <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
          <div class="empty-rest" @click="reset">恢复默认</div>
        </div>
      </template>
      <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
      </el-table-column>
      <el-table-column prop="no" width="200" label="申请单号">
        <template slot-scope="scope">
          <span>
            <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
          </span>
        </template>
      </el-table-column>
      <el-table-column min-width="175" prop="hospitalName" label="申报机构"></el-table-column>
      <el-table-column width="120" prop="annual" label="所属年度"></el-table-column>
      <el-table-column prop="createdUserName" width="140" label="申请人"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="ownerDeptName" width="180" label="所属科室"></el-table-column>
      <el-table-column prop="productNumber" width="150" label="产品数"></el-table-column>
      <el-table-column prop="totalNumber" width="150" label="申请总数量"></el-table-column>
      <el-table-column width="250" prop="deliveryTime" label="申报时间">
        <template slot-scope="scope">
          {{
            parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}")
          }}</template>
      </el-table-column>
      <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames" />
      <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
        <template slot-scope="scope">
          <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions"
            @success="getData" :tableCode="route.name"></approve-status>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column> -->
      <el-table-column prop="operation" fixed="right" label="操作" width="300">
        <template slot-scope="scope">
          <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
          <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
            v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
          <el-button v-else-if="
            scope.row.status != 1 &&
            scope.row.status != 2 &&
            tableAcl.indexOf('Edit') != -1
          " type="text" v-preventReClick @click="handleUpdate(scope.row)"
            class="margin-left20 color-blue">编辑</el-button>

          <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
            @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
    
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import { GetVolumePurchases, RemoveVolumePurchases } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import Info from './info';
import { AnnualOptions, ApproveStatusOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      AnnualOptions: AnnualOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [
        {
          name: "单号",
          type: "input",
          code: "keyWord",
        },

        {
          name: "年度",
          type: "select",
          code: "annual",
          data: AnnualOptions,
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
        {
          name: "申报人",
          type: "select",
          code: "createdUser",
          filterMethod: this.getUsers,
          data: [],
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
      ],

      finishVisible: false,
      finishForm: {},
      finishFormRules: {
        reason: [{ required: true, message: "请输入终止原因", trigger: "blur" }],
      },
    };
  },
  methods: {
    getRowKey(row) {
      return row.id;
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData() {
      this.loading = true;
      GetVolumePurchases(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查看信息
    handleInfo(row) {
      // this.$router.push("/volume-purchase-edit?formMode=0&id=" + row.id);
      this.routePushWithParams("/volume-purchase-edit", this.query, {
        formMode: 0,
        id: row.id,
      });
    },
    // 新建
    handleAdd() {


      // this.$router.push("/volume-purchase-edit?formMode=1");
      this.routePushWithParams("/volume-purchase-edit", this.query, { formMode: 1 });
    },
    // 编辑
    handleUpdate(row) {
      // this.$router.push("/volume-purchase-edit?formMode=2&id=" + row.id);
      this.routePushWithParams("/volume-purchase-edit", this.query, {
        formMode: 2,
        id: row.id,
      });
    },
    // 审批
    handleApprove(row) {
      // this.$router.push("/volume-purchase-edit?formMode=3&id=" + row.id);
      this.routePushWithParams("/volume-purchase-edit", this.query, {
        formMode: 3,
        id: row.id,
      });
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 删除部门
    handleDelete(row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveVolumePurchases({ ids });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset() {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.getData();
    },
    queryChange() {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    filterChange(query) {
      this.query = Object.assign(this.query, query);
      this.getData();
    },
    handleCopy() {
      let annual = new Date().getFullYear();
      // this.routePushWithParams("/" + this.editPath, this.query, { formMode: 1, year: year - 1 });
      this.routePushWithParams("/volume-purchase-edit", this.query, {
        formMode: 2,
        annual: annual - 1,
      });
    },
  },
  created() {
    // 分页组件默认值需要早created
    if (this.$route.params && JSON.stringify(this.$route.params) != "{}") {
      this.query = this.$route.params;
    }
  },
  mounted() {
    // 查询组件默认值需要在mounted
    // console.log(this.$route, 'route')
    if (this.$route.params && JSON.stringify(this.$route.params) != "{}") {
      this.$refs["selectFilter"].query = this.query;
    }
    // if (!this.$route.params.state) {
    //   // this.query.state = 0
    //   // this.$refs["selectFilter"].query.stateName = 0
    // }

    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
